var api = require("!../../../../bluecf-ui-classic-c9f3cc4a3eee/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../bluecf-ui-classic-c9f3cc4a3eee/node_modules/css-loader/dist/cjs.js!../../../../bluecf-ui-classic-c9f3cc4a3eee/node_modules/postcss-loader/src/index.js??ref--9-2!../../../../bluecf-ui-classic-c9f3cc4a3eee/node_modules/resolve-url-loader/index.js!../../../../bluecf-ui-classic-c9f3cc4a3eee/node_modules/sass-loader/dist/cjs.js??ref--9-4!./brand.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);

var exported = content.locals ? content.locals : {};



module.exports = exported;